module.exports = __webpack_public_path__ + "assets/img/product-country3-new.263cb582.png";